import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import us from './languages/en.json'
import br from './languages/pt.json'

const resources = {
  us: {
    translation: us,
  },
  br: {
    translation: br,
  },
}

export type Languages = keyof typeof resources

const FALLBACK_LANG: Languages = 'br'

/**
 * Detecta o idioma a partir da querystring (?lang=). Aceita tanto os codes
 * internos (br/us) quanto aliases comuns (pt/pt-br -> br, en/us-en -> us).
 * Fallback: 'br'.
 */
const detectLanguage = (): Languages => {
  if (typeof window === 'undefined') return FALLBACK_LANG
  const raw = new URLSearchParams(window.location.search)
    .get('lang')
    ?.toLowerCase()
    .trim()
  if (!raw) return FALLBACK_LANG
  if (raw === 'us' || raw.startsWith('en')) return 'us'
  if (raw === 'br' || raw.startsWith('pt')) return 'br'
  return FALLBACK_LANG
}

export const i18nConfig = {
  i18n: i18n.use(initReactI18next).init({
    compatibilityJSON: 'v3',
    lng: detectLanguage(),
    fallbackLng: FALLBACK_LANG,
    resources,
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
  }),
}

export const changeLanguage = (lng: Languages) => {
  i18n.changeLanguage(lng)
}

export default i18nConfig.i18n
